<template>
    <div v-if="getUser && getDrawerAppInClientAccounts.show"
         :class="['ap2-modal', 'ap2-modal-md', 'ap2-modal-is-drawer', getDrawerAppInClientAccounts.show ? 'open' : null]"
         id="drawer-test">
        <div class="modal-wrapper ">
            <div class="ap2-modal-header">
                <div class="modal-header-title-wrapper">
                    <div class="modal-header-reference">
                        {{ getCurrentClient.name }}
                    </div>
                    <div class="modal-header-title">
                        New Account(s)
                    </div>
                </div>
                <div class="modal-header-close close-modal-demo">
                    <svg @click="closeDrawer()"
                         height="1em"
                         viewBox="0 0 384 512"
                         xmlns="http://www.w3.org/2000/svg">
                        <path class="svg-fill"
                              d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
                    </svg>
                </div>
            </div>
            <div class="ap2-modal-content">
                <perfect-scrollbar>
                    <div
                            class="drawer-title-section ap2-toggle-collapse show"
                            data-ap2-target="#tst-options">
                    <span class="ap2-toggle-collapse-title">
                        Accounts
                    </span>
                        <span class="ap2-toggle-collapse-chevron">
                        <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                            <path class="svg-fill"
                                  d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"></path>
                        </svg>
                    </span>
                    </div>
                    <div id="tst-options" class="collapsable-element show">
                        <div v-if="accounts.length > 0" class="form-group ap2-form-group mt-2">
                            <div class="ap2-form-control-has-icon left is-search">
                                <input :value="filterItemsText"
                                       @input="filterItemsText=$event.target.value"
                                       class="form-control ap2-form-control"
                                       placeholder="Search"
                                       type="text">
                                <span class="icon" :style="'-webkit-mask-image: url(' + search + ')'"></span>
                            </div>
                        </div>
                        <ul v-if="accounts.length > 0" class="input-selector-list has-visible-input">
                            <li v-for="item in getItemsWithFilter"
                                class="form-label"
                                :key="item.id">
                                <input v-model="itemsSelected"
                                       type="checkbox"
                                       :id="item.id"
                                       :value="item">
                                <label :for="item.id">
                                    {{ item.name }}
                                </label>
                            </li>
                        </ul>
                    </div>
                </perfect-scrollbar>
            </div>
            <div class="ap2-modal-footer modal-controls">
                <div class="modal-controls">
                    <button @click="cancelButtonActions()"
                            type="button"
                            class="ap2-btn btn btn-dark close-modal-demo">
                        Cancel
                    </button>
                    <button @click="setSelectedItems()"
                            type="button"
                            class="ap2-btn btn btn-success close-modal-demo">
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import search from '@/assets/images/magnifying-glass-solid.svg';
    import {PerfectScrollbar} from 'vue3-perfect-scrollbar';

    export default {
        name: "AppInClientAccountsDrawer",
        components: {PerfectScrollbar},
        data() {
            return {
                filterItemsText: null,
                search: search,
                accounts: [],
                itemsSelected: [],
            }
        },
        computed: {
            ...mapGetters(['getDrawerAppInClientAccounts', 'getConstants', 'getCurrentClient', 'getUser']),
            getItemsWithFilter() {
                let items = [];
                if (this.filterItemsText) {
                    _.forEach(this.accounts.filter(element => _.toLower(element.name).includes(_.toLower(this.filterItemsText))), item => {
                        items.push(item);
                    })
                } else {
                    _.forEach(this.accounts, item => {
                        items.push(item);
                    })
                }
                return items
            },
        },
        mounted() {
            this.$store.watch(state => state.drawerAppInClientAccounts, (value) => {
                if (value.show) {
                    this.accounts = value.data.accountsPlatform;
                }
            }, {deep: true});
        },
        methods: {
            closeDrawer() {
                _.set(this.getDrawerAppInClientAccounts, 'show', false);
                this.itemsSelected = [];
                this.accounts = [];
                this.filterItemsText = null;
                this.$emit('dispatch-close-drawer')
            },
            setSelectedItems() {
                _.set(this.getDrawerAppInClientAccounts, 'result', this.itemsSelected);
                this.closeDrawer()
            },
            cancelButtonActions() {
                this.itemsSelected = this.getDrawerAppInClientAccounts.data.itemsSelected;
                this.closeDrawer();
            },
            getSelectAccountsObjects() {
                let selectedAccounts = []
                _.forEach(this.accounts, account => {
                    if (_.includes(this.itemsSelected, account.name)) {
                        account.platform = this.selectedPlatform
                        selectedAccounts.push(account)
                    }
                })
                return selectedAccounts;
            }
        }
    }
</script>